var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMobile128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/xLarge./Mobile128",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(30.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#4F4C4D",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 1.5,
    y: 1.5,
    width: 65,
    height: 109,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,88.5 L1.5,104 C1.5,107.589851 4.41014913,110.5 8,110.5 L60,110.5 C63.5898509,110.5 66.5,107.589851 66.5,104 L66.5,88.5 L1.5,88.5 Z",
    id: "Rectangle",
    stroke: "#4F4C4D",
    strokeWidth: 3,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Button",
    fill: "#4F4C4D",
    x: 47,
    y: 98,
    width: 10,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Button",
    stroke: "#4F4C4D",
    strokeWidth: 3,
    fill: "#FFFFFF",
    cx: 34,
    cy: 99,
    r: 4.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMobile128);
export default __webpack_public_path__ + "static/media/pictogramMobile128.d9a3df6d4372ab731369b1164c7781f0.svg";
export { ForwardRef as ReactComponent };